import { render, staticRenderFns } from "./BulkSend.vue?vue&type=template&id=5133c78d&"
import script from "./BulkSend.vue?vue&type=script&lang=js&"
export * from "./BulkSend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports